import { Component, AfterContentInit, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { DocumentDTO, getSimpleIdentifierFromString, ExecutionDivisionDTO, DivisionDTO } from '../../api/plyca-dtos';
import {
  ContractModificationDTO, ContractDTO, ProjectEntityDTO, RegisterContractModificationDTO,
  CompanyDocDTO, SpecialCondTracingReportDTO, ContractSpecialConditionsDTO, KpiRecordDTO,
  ActionResultDTO, ResultTypeDTO, DossierSituation, FilingStateType, CustomFieldDTO,
  RepresentativeDTO,
  CompanyProjectDTO,
  CompanyDTO
} from '../../api/plyca-dtos-v2';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UIService } from '../../ui.service';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { finalize, switchMap, take } from 'rxjs/operators';
import { Configuration } from '../../conf/app.constants';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { contractModificationTypesComponent } from '../contractModifications/contractModificationTypes.component';
import { TranslateService } from '@ngx-translate/core';
import { DossierActionsListComponent } from '../dossierActions/dossierActionsList.component';
import { HttpParams } from '@angular/common/http';
import { LongTextEditorComponent, LongTextDTOModal } from '../../components/forms/longTextEditor.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { documentViewerComponent } from '../../documents/documentViewer/documentViewer.component';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import * as  moment from 'moment';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { ExecutionDivisionEditionComponent } from './executioDivision.edition.component';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { PropertyService } from '../../properties/property.service';
import { ProfileService } from '../../../services/profile.services';
import { UserService } from '../../user.service';
import { DocumentService } from '../../documents/document.service';
import { CompanyAdminComponent, ViewDTOModal } from '../../company/companyAdmin.component';

@Component({
  selector: 'contracts',
  templateUrl: 'contracts.template.html',
  providers: [DialogService]
})
export class ContractsComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {
  // showHeader = true;
  dossierId: string;
  divisionId: string;

  // DTOS DE LA PANTALLA
  project: ProjectEntityDTO;
  contractList = [];

  contractLotsEnabled: false;
  contractDocsEnabled: false;
  contractModificationsEnabled: false;
  contractExecutionEnabled: false;
  contractEspecialesEjecucionEnabled: false;
  newname = 'nueva fase';
  customFieldConfiguration: CustomFieldDTO[]; // Listado de campos personalizables del contrato visibles en el interface
  contractModificationVisibleCustomFields: CustomFieldDTO[]; // Listado de campos personalizables de la incidencia visibles en el interface
  viewRegisterNumber = false;
  actualContract = CompanyDocDTO;
  specialConditionsReports: SpecialCondTracingReportDTO[];
  kpisRecords: KpiRecordDTO[];
  kpisDateList: any[];
  executionPercent: number;
  guaranteePercent: number;
  cliente: any;
  actionDeleteAvailable: boolean = null;
  contractApprovedStatuses: string;
  contractModificationApprovedStatuses: string;
  activeExtensionBreakdown = false;

  // Incidencias
  newContractModificationVisible = true;
  contractModificationReplyca = false;

  collapsedContracts = [];
  selectedContractTabs = [];

  constructor(
    public plycaService: PlycaDataService,
    public helpService: HelpService,
    private elem: ElementRef,
    private headerService: HeaderActionsService,
    private uiService: UIService,
    private route: ActivatedRoute,
    private router: Router,
    public configuration: Configuration,
    private waitService: WaitLoadingService,
    public translate: TranslateService,
    public dialogService: DialogService,
    public propertyService: PropertyService,
    public profileService: ProfileService,
    public userService: UserService,
    private appConfig: AppConfiguration,
    private plycaErrorHandler: PlycaErrorHandler,
    private documentService: DocumentService
  ) {
    super();
    this.waitService.startWaiting();

    let newContractModificationProfiles = appConfig.getValue('newContractModification.profiles');
    let newContractModificationReplycaProfiles = appConfig.getValue('contractModificationReplyca.profiles');
    // Configuracion de visibilidad y formato de los campos personalizables del contrato
    this.customFieldConfiguration = this.appConfig.getValue('contractVisibleCustomFields');
    // Configuracion de visibilidad y formato de los campos personalizables de la incidencia
    this.contractModificationVisibleCustomFields = this.appConfig.getValue('contractModificationVisibleCustomFields');
    // Estados contratos e incidencias aprobadas
    this.contractApprovedStatuses = this.appConfig.getValue('contract.approvedStatuses');
    this.contractModificationApprovedStatuses = this.appConfig.getValue('contractModification.approvedStatuses');

    this.newContractModificationVisible = this.userService.hasRoles(newContractModificationProfiles, 'CONTRATACION');
    this.contractModificationReplyca = this.userService.hasRoles(newContractModificationReplycaProfiles, 'RECO');

    this.activeExtensionBreakdown = this.appConfig.getValue('activeExtensionBreakdown');

    this.subscribe(this.route.params, params => {
      this.dossierId = params['id'];
    });
    this.cliente = this.appConfig.getValue('cliente');
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.DOSSIER_CONTRACTS));
    this.loadInfo();
  }
  ngOnInit(): void {

  }

  ngAfterContentInit(): void {
    this.waitService.startWaiting();
    this.subscribe(this.route.queryParams, params => {
      this.divisionId = params['divisionId'];
      if (this.divisionId) {
        this.divisionId = this.divisionId + '<>' + this.dossierId;
      }
    });
    this.headerService.setTaskDescription(
      this.elem,
      'Contratos del Expediente',
      'fa-file-contract',
      true
    );

    this.headerService.clearActions();

    this.subscribe(this.headerService
      .addAction('General.reload', 'fas fa-sync-alt', 'btn-primary', true),
      () => {
        this.loadInfo();
      });
    // this.headerService
    //   .addAction(
    //     'Crear contrato',
    //     'fas fa-lg fa-plus',
    //     'btn-outline-secondary',
    //     true
    //   )
    //   .subscribe(() => {
    //     this.newContract();
    //   });
    this.subscribe(this.headerService
      .addAction(
        'General.back',
        'fas fa-chevron-left fa-lg',
        'btn-outline-secondary',
        true
      ),
      () => {
        this.uiService.routeBack();
      });
  }

  ngOnDestroy() {
    this.headerService.clearActions();
    super.ngOnDestroy();
  }


  loadInfo() {
    this.waitService.startWaiting();
    if (this.dossierId) {
      this.subscribe(forkJoin(
        // Consultamos el expediente con el flag que nos indica si somos usuario en modo soporte
        this.plycaService.getProcurementProjectContract(this.dossierId, '?expand=expansionSet:ALLOWED_FOR_SUPPORT'),
        this.plycaService.query<ContractDTO>(
          this.configuration.CONTRACTS_SERVICE_URL + '?',
          {
            identifier: this.dossierId
          }
        )
      )
        .pipe(finalize(() => this.waitService.cancelWaiting())),
        result => {
          if (result[0]) {
            this.project = result[0];
          }
          if (result[1] && result[1].content) {
            this.contractList = result[1].content;

            /*if (this.contractList.length == 1)
              this.loadOneContract(null, this.contractList[0]);*/
          } else {
            this.contractList = [];
          }
          console.log('CONSULTADOS CONTRATOS:', this.contractList);
          this.waitService.cancelWaiting();
        });
    }
  }

  handleChange(e, contract: ContractDTO) {
    this.selectedContractTabs[contract.division.identifier] = e.index;
  }

  loadOneContract(event: any, contract: ContractDTO) {
    this.collapsedContracts[contract.division.identifier] = event?.collapsed;

    if ((!event || !event.collapsed) && !contract['loaded']) {
      this.waitService.startWaiting();
      this.plycaService.query<ContractDTO>(
        this.configuration.CONTRACTS_SERVICE_URL + '?',
        {
          identifier: this.dossierId,
          division: getSimpleIdentifierFromString(contract.division.identifier),
          expand: 'expansionSet:WEB_CLIENT'
        }
      ).pipe(finalize(() => this.waitService.cancelWaiting()))
        .subscribe(result => {
          var contractIndex = this.contractList.findIndex(x => x.division == contract.division);
          Object.assign(this.contractList[contractIndex], result.content[0]);
          this.contractList[contractIndex]['loaded'] = true;
          this.loadContractInfo(contract);
          this.loadContractConfiguration(contract);
          this.waitService.cancelWaiting();
        });
    }
  }

  updatecontinuationDossierTracing(contract: ContractDTO) {
    this.waitService.startWaiting();
    this.plycaService.patch<ContractDTO>(this.configuration.CONTRACTS_SERVICE_URL, contract, 'UPDATE_CONT_DOSSIER_TRACKING')
      .pipe(finalize(() => this.waitService.cancelWaiting()))
      .subscribe(result => {
        this.waitService.cancelWaiting();
      }
        , err => {
          console.log('ERROR ACTIVANDO SEGUIMIENTO EXPEDIENTE DE CONTINUACION DE UN CONTRATO');
        });
  }

  private loadContractInfo(contract: ContractDTO) {
    contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED'] = false;
    contract['EXT_DATA_DOCUMENTS_LOADED'] = false;
    contract['EXT_DATA_EXECUTIONPHASES_LOADED'] = false;
    contract['EXT_DATA_RIL_DOSSIER'] = {};

    // LOTES DEL CONTRATO (TODO: ELIMINAR)

    if (contract.procurementProjectInfo && contract.procurementProjectInfo.apportioned) {
      contract['LOTES'] = contract.contractLots;
    }
    this.subscribe(this.plycaService
      .query<ContractModificationDTO>(
        this.configuration.CONTRACT_MODIFICATIONS_SERVICE_URL,
        {
          dossierId: this.dossierId,
          contractDivision: getSimpleIdentifierFromString(
            contract.division.identifier
          )
          , expand: 'expansionSet:CUSTOMFIELDS_COLLECTION'
          // ,expand: 'expansionSet:webClient'
        }
      ).pipe(
        finalize(() => contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED'] = true)
      ),
      contractModifications => {
        let _contractModifications;
        if (contractModifications && contractModifications.content) {
          console.log(
            'INCIDENCIAS DEL CONTRATO ' +
            contract.identifier +
            ' -> ' +
            contractModifications
          );
          _contractModifications = contractModifications.content;
        } else {
          _contractModifications = [];
        }
        contract['EXT_DATA_CONTRACTMODIFICATIONS'] = _contractModifications;
        contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED'] = true;
      });
    // }
    // }

    // DOCUMENTOS DEL CONTRATO
    // if (this.contractDocsEnabled) {
    let params = new HttpParams();
    params = params.append('expand', 'expansionSet:DOCUMENTS_OF_CONTRACT');
    params = params.append('dossierId', this.dossierId);
    params = params.append('division', getSimpleIdentifierFromString(contract.division.identifier));

    let documentClasses = this.appConfig.getValue('contracts.visibleDocuments');
    if (documentClasses) {
      if (documentClasses instanceof Array) {
        documentClasses.forEach(documentClass => params = params.append('documentClasses', documentClass))
      } else {
        params = params.append('documentClasses', documentClasses)
      }

      this.subscribe(this.plycaService
        .query<DocumentDTO>(this.configuration.DOCUMENTS_SERVICE_URL, params).pipe(
          finalize(() => contract['EXT_DATA_DOCUMENTS_LOADED'] = true)
        ),
        documents => {
          let docs;
          if (documents && documents.content) {
            console.log(
              'DOCUMENTOS DEL CONTRATO ' +
              contract.identifier +
              ' -> ' +
              documents
            );
            docs = documents.content;
          } else {
            docs = [];
          }
          contract['EXT_DATA_DOCUMENTS'] = docs;
          contract['EXT_DATA_DOCUMENTS_LOADED'] = true;
        });
    } else {
      contract['EXT_DATA_DOCUMENTS_LOADED'] = true;

    }
    // }

    // CARPETAS DE FASE EJECUCION
    this.loadExecutionDivisions(contract);

    // CONDICIONES ESPECIALES DE EJECUCION
    let atribParams = 'PROPUESTAID=' + contract.division.project.identifier
      + '&DIVISION=' + getSimpleIdentifierFromString(contract.division.identifier);
    this.subscribe(this.plycaService.getAttributeValue(
      'SEG_COND_ESP_EJEC_STD',
      atribParams
    ),
      x => {
        this.specialConditionsReports = [];
        if (x.values) {
          x.values.forEach(element => {
            let report: SpecialCondTracingReportDTO = new SpecialCondTracingReportDTO();
            report.specialConditionIds = element.columns['UUID_COND'].value.split(';');
            if (element.columns['PROX_VENC'].value) {
              report.nextDeadline = moment(element.columns['PROX_VENC'].value, 'DD-MM-YYYY HH:mm:ss').toDate();
            }
            if (element.columns['FECHA_EMISION'].value) {
              report.requestDate = moment(element.columns['FECHA_EMISION'].value, 'DD-MM-YYYY HH:mm:ss').toDate();
            }
            if (element.columns['FECHA_RESP'].value) {
              report.responseDate = moment(element.columns['FECHA_RESP'].value, 'DD-MM-YYYY HH:mm:ss').toDate();
            }
            if (element.columns['VALORACION_MEDIA'].value) {
              report.valorationAverage = +element.columns['VALORACION_MEDIA'].value;
            }
            report.responseInPeriod = element.columns['RESPUESTA_EN_PLAZO'].value;
            if (element.columns['DOC_RESP_UUID'].value) {
              report.responseDoc = new DocumentDTO();
              report.responseDoc.identifier = element.columns['DOC_RESP_UUID'].value;
            }
            if (element.columns['DOC_INF_UUID'].value) {
              report.valorationDoc = new DocumentDTO();
              report.valorationDoc.identifier = element.columns['DOC_INF_UUID'].value;
            }
            this.specialConditionsReports.push(report);
          });
        }

      },
      err => {
        console.log('Error cargando datos atributo: SEG_COND_ESP_EJEC_STD');
        console.log(err);
      });

    // Porcentajes de ejecucion (CONTRATO_PORCEN_EJEC_STD)
    let atribParams2 = 'PROPUESTAID=' + contract.division.project.identifier
      + '&DIVISION=' + getSimpleIdentifierFromString(contract.division.identifier);
    this.subscribe(this.plycaService.getAttributeValue(
      'CONTRATO_PORCEN_EJEC_STD',
      atribParams2
    ),
      x => {
        this.executionPercent = 0;
        this.guaranteePercent = 0;
        if (x.values) {
          x.values.forEach(element => {
            if (element.columns['PORCEN_IMP'].value) {
              this.executionPercent = parseInt(element.columns['PORCEN_IMP'].value);
            }
            if (element.columns['PORCEN_PLAZO_GAR'].value) {
              this.guaranteePercent = parseInt(element.columns['PORCEN_PLAZO_GAR'].value);
            }
          });
        }

      },
      err => {
        console.log('Error cargando datos atributo: CONTRATO_PORCEN_EJEC_STD');
        console.log(err);
      });

    // SEGUIMIENTO KPIs
    this.kpisRecords = [];
    atribParams = 'PROPUESTAID=' + contract.division.project.identifier + '&DIVISION='
      + getSimpleIdentifierFromString(contract.division.identifier);
    this.subscribe(this.plycaService.getAttributeValue(
      'SEGUIMIENTO_KPIS_CONTR_STD',
      atribParams
    ).pipe((finalize(() => {
      this.kpisDateList = this.kpisRecords.map(item => item.date).filter((date, i, self) =>
        self.findIndex(d => d.getTime() === date.getTime()) === i
      ).map(x => {
        var obj = {};
        obj['header'] = moment(x).format('MMM/YYYY');
        obj['date'] = x;
        return obj;
      });
    }))
    ),
      x => {
        if (x.values) {
          x.values.forEach(element => {
            let record: KpiRecordDTO = new KpiRecordDTO();
            record.date = moment(element.columns['FECHA'].value, 'DD-MM-YYYY HH:mm:ss').toDate();
            record.value = +element.columns['VALOR'].value;
            record.kpiId = element.columns['KPI_ID'].value;
            record.kpiDescription = element.columns['KPI_DESC'].value;
            record.levelId = element.columns['NIVEL_ID'].value;
            record.levelDescription = element.columns['NIVEL_DESC'].value;
            this.kpisRecords.push(record);
          });
        }
      },
      err => {
        console.log('Error cargando datos atributo: SEGUIMIENTO_KPIS_CONTR_STD');
        console.log(err);
      });
    //EXPEDIENTE RIL
    if (contract.company && contract.company) {
      this.plycaService.query<CompanyProjectDTO>(
        this.configuration.COMPANYPROJECT_SERVICE_URL + '?',
        {
          companyId: contract.company.identifier
        }
      ).pipe(finalize(() => this.waitService.cancelWaiting()))
        .subscribe(result => {
          if (result) {
            contract['EXT_DATA_RIL_DOSSIER'] = result.content[0];
          }
        });
    }

  }

  getSpecialCondReports(specialCondition: ContractSpecialConditionsDTO): SpecialCondTracingReportDTO[] {
    if (this.specialConditionsReports)
      return this.specialConditionsReports.filter(x => x.specialConditionIds.filter(id => id === specialCondition.identifier).length > 0);
    else
      return null;
  }

  getSpecialCondReportStatus(report: SpecialCondTracingReportDTO): string {
    if (report.valorationAverage != null && report.valorationAverage >= 100) {
      return this.translate.instant('Contracts.executionConditionsMonitoring.status.total')
    } else if (report.valorationAverage != null && report.valorationAverage > 0) {
      return this.translate.instant('Contracts.executionConditionsMonitoring.status.partial')
    } else if (report.valorationAverage != null && report.valorationAverage == 0) {
      return this.translate.instant('Contracts.executionConditionsMonitoring.status.noCompliance')
    } else if (report.responseDate != null && !report.valorationDoc) {
      return this.translate.instant('Contracts.executionConditionsMonitoring.status.pendingAssetment')
    } else if (!report.responseDate) {
      return this.translate.instant('Contracts.executionConditionsMonitoring.status.pendingSubmit')
    }
  }

  getSpecialCondReportClass(report: SpecialCondTracingReportDTO): string {
    if (report.valorationAverage != null && report.valorationAverage >= 100) {
      return 'text-success'
    } else if (report.valorationAverage != null && report.valorationAverage > 0) {
      return 'text-warning'
    } else if (report.valorationAverage != null && report.valorationAverage == 0) {
      return 'text-danger'
    }
  }

  getSpecialCondReportIcon(report: SpecialCondTracingReportDTO): string {
    if (report.valorationAverage != null && report.valorationAverage >= 100) {
      return 'fa-thumbs-up'
    } else if (report.valorationAverage != null && report.valorationAverage > 0) {
      return 'fa-thumbs-up'
    } else if (report.valorationAverage != null && report.valorationAverage == 0) {
      return 'fa-thumbs-down'
    } else { return 'fa-hourglass-half'; }
  }

  getKpisTypeList(): KpiRecordDTO[] {
    var types: KpiRecordDTO[] = new Array(0);
    this.kpisRecords.forEach(x => {
      if (types.filter(y => y.kpiId === x.kpiId).length == 0) {
        let type: KpiRecordDTO = new KpiRecordDTO();
        type.kpiId = x.kpiId;
        type.kpiDescription = x.kpiDescription;
        types.push(type);
      }
    });
    return types;
  }

  getKpisColumnasFijas(): any[] {
    return [{ 'header': this.translate.instant('Contracts.kpis.type') }];
  }

  getKpiByTypeAndDate(id: string, data: any): KpiRecordDTO {
    let kpi: KpiRecordDTO = this.kpisRecords.find(x => x.kpiId == id && x.date.getTime() === data.date.getTime());
    return kpi ? kpi : new KpiRecordDTO();
  }

  getKpiIcon(id: string, data: any): string {
    let kpi: KpiRecordDTO = this.kpisRecords.find(x => x.kpiId == id && x.date.getTime() === data.date.getTime());
    if (kpi && kpi.levelId == '2') {
      return 'fa-thermometer-empty text-success';
    } else if (kpi && kpi.levelId == '1') {
      return 'fa-thermometer-half text-secondary';
    } else if (kpi && kpi.levelId == '0') {
      return 'fa-thermometer-full text-danger';
    }
    return '';
  }

  loadExecutionDivisions(contract: ContractDTO) {
    let url = this.configuration.EXECUTION_PHASE_DOSSIER_SERVICE_URL.replace(
      '{dossierId}',
      this.dossierId
    ).replace(
      '/{divisionId}',
      // getSimpleIdentifierFromString(contract.division.identifier)
      ''
    );
    // let url = this.configuration.EXECUTION_PHASE_SERVICE_URL_v2.replace(
    //   '{contractId}',
    //   contract.identifier
    // );
    this.subscribe(this.plycaService
      .query<ExecutionDivisionDTO>(url, {
        contractId: contract.identifier
      }).pipe(finalize(() => contract['EXT_DATA_EXECUTIONPHASES_LOADED'] = true)),
      executionPhases => {
        let _executionPhases: ExecutionDivisionDTO[];
        if (executionPhases && executionPhases.content) {
          console.log(
            'INCIDENCIAS DEL CONTRATO ' +
            contract.identifier +
            ' -> ' +
            executionPhases
          );
          _executionPhases = executionPhases.content;
        } else {
          _executionPhases = [] as ExecutionDivisionDTO[];
        }
        contract['EXT_DATA_EXECUTIONPHASES'] = _executionPhases;
        contract['EXT_DATA_EXECUTIONPHASES_LOADED'] = true;
      });
  }

  viewDocument(doc: DocumentDTO) {
    let config: DynamicDialogConfig = {
      header: doc.name,
      width: '97%',
      styleClass: 'searchStyle'
    };
    config.data = {
      'id': doc.identifier
    }
    let modal = this.dialogService.open(documentViewerComponent, config);
    this.subscribe(modal.onClose.pipe(
      switchMap(() => this.helpService.showContextHelpObservable(HelpType.DOSSIER_CONTRACTS))));
  }

  openContract(contract: ContractDTO) {
    this.router.navigate(['contracts', contract.identifier]);
  }

  close() { }

  newContract() {
    this.router.navigate(['contracts', 'f35680ad-3da5-4f6c-a013-9b6b8dc5c460']);
  }

  newContractModification(contract: ContractDTO, contractModification?: any) {
    if (contractModification) {
      this.router.navigate([
        'contractModifications',
        contractModification.identifier
      ]);
    } else {
      this.subscribe(this.openActiveContractModificationsList(contract).onClose, result => {
        if (result) {
          this.router.navigate(['contractModifications', 'new'], {
            queryParams: {
              projectIdentifier: this.dossierId,
              contractDivision: getSimpleIdentifierFromString(
                contract.division.identifier
              ),
              type: result,
            }
          });
        }
      });
    }
  }

  openActiveContractModificationsList(contract: ContractDTO) {
    let config: DynamicDialogConfig = {
      header: this.translate.instant('ContractModification.new'),
      width: '70%',
      style: { overflow: 'hidden', 'max-height': '70%' },
      styleClass: 'searchStyle'
    };
    config['contractId'] = contract.identifier;

    if (contract.division && contract.division.project && contract.division.project.documentClass.identifier === '00600') {
      config['isProjectReplyca'] = contract.division.project.documentClass.identifier === '00600';
    } else {
      config['isProjectReplyca'] = false;
    }
    return this.dialogService.open(contractModificationTypesComponent, config);
  }

  updateExecutionPhase(contract: ContractDTO, executionPhase: ExecutionDivisionDTO) {

    let url = this.configuration.EXECUTION_PHASE_DOSSIER_SERVICE_URL.replace(
      '{dossierId}',
      executionPhase.project.identifier
    );


    this.waitService.startWaiting();
    this.subscribe(this.plycaService
      .update<ExecutionDivisionDTO>(url, executionPhase).pipe(finalize(() => {
        this.waitService.cancelWaiting();
      })),
      () => this.loadInfo(),
      (error: any) => {
        this.plycaErrorHandler.showServerError(error);
        return throwError(error);
      });
  }
  newExecutionPhase(contract: ContractDTO, name: string) {
    // let url = this.configuration.EXECUTION_PHASE_SERVICE_URL.replace(
    //   '{dossierId}',
    //   this.dossierId
    // ).replace(
    //   '{divisionId}',
    //   getSimpleIdentifierFromString(contract.division.identifier)
    // );
    let url = this.configuration.EXECUTION_PHASE_CONTRACT_SERVICE_URL.replace(
      '{contractId}',
      contract.identifier
    );

    let newExecutionPhase = new ExecutionDivisionDTO();
    newExecutionPhase.name = name;
    newExecutionPhase.parent = contract.division;
    this.waitService.startWaiting();
    this.subscribe(this.plycaService
      .insert<ExecutionDivisionDTO>(url, newExecutionPhase).pipe(finalize(() => {
        this.waitService.cancelWaiting();
      })),
      () => this.loadInfo(),
      (error: any) => {
        this.plycaErrorHandler.showServerError(error);
        return throwError(error);
      });
  }

  isExecutionPhaseClosed(executionPhase: ExecutionDivisionDTO) {
    if (executionPhase && executionPhase.phase) {
      return (
        getSimpleIdentifierFromString(executionPhase.phase.identifier) !== '40'
      );
    } else {
      return false;
    }
  }

  public isDefinedInDivisions(contract: ContractDTO, customFieldName: String) {
    if (contract != null && contract['EXT_DATA_EXECUTIONPHASES'] != null) {
      for (let executionPhase of contract['EXT_DATA_EXECUTIONPHASES']) {
        if (this.isDefined(executionPhase, customFieldName)) {
          return true;
        }
      }
    }
    return false;
  }

  public reopenExecutionPhase(contract: ContractDTO, executionPhase: ExecutionDivisionDTO) {
    executionPhase.phase.identifier = '40<>EXPFASE';
    this.updateExecutionPhase(contract, executionPhase);
  }

  public isDefined(executionPhase: ExecutionDivisionDTO, customFieldName: String) {
    return (executionPhase && executionPhase['customFieldDefinitions'] && executionPhase['customFieldDefinitions'][customFieldName] !== undefined)
  }

  openExecutionPhaseActions(executionPhase: ExecutionDivisionDTO) {
    let title = 'Acciones de ' + executionPhase.name;
    let contract = this.contractList.find(obj => getSimpleIdentifierFromString(obj.division.identifier) == getSimpleIdentifierFromString(executionPhase.parent.identifier));
    if (contract) {
      title = '[' + contract.division.name + '] ' + title;
    }
    let config: DynamicDialogConfig = {
      header: title,
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%', 'min-height': '70vh' },
      styleClass: 'formEdition'
    };
    // config['item'] = new ViewDTOModal(row, 'companyDetailISettings.json');
    // config['esAltaEmpresa'] = esAlta;
    config['dossierId'] = this.dossierId;
    config['divisionId'] = getSimpleIdentifierFromString(
      executionPhase.identifier
    );
    const ref = this.dialogService.open(DossierActionsListComponent, config);
    this.subscribe(ref.onClose, result => {
      this.loadInfo();
    });
  }


  // Metodo que habilita o deshabilita el boton en funcion de la fase y de la situacion.
  // Si es REPLYCA, la faseEnabled siempre es true.
  // Si es CONTRATACION, la falseEnabled depende.
  contractModificationsAvailable(contract: ContractDTO) {
    let situationEnabled = this.getEnabledSituationClass();
    let faseEnabled = true;
    if (this.contractModificationReplyca && this.project && this.project.documentClass.identifier !== '00600') {
      faseEnabled = contract.division.phase.identifier !== '0<>EXPFASE' && contract.division.phase.identifier !== '50<>EXPFASE';
    }
    return (situationEnabled && faseEnabled);
  }

  isContractModificationEditable(_contactModification: ContractModificationDTO) {
    if (_contactModification && _contactModification.document &&
      this.contractModificationReplyca || this.project && this.project.documentClass && this.project.documentClass.identifier !== '00600') {
      return _contactModification.document.currentState.identifier === '17';
    }
    return false;
  }

  absoluteValue(value: number): number {
    return Math.abs(value);
  }

  private getEnabledSituationClass(): boolean {
    let enabled = true;
    if (this.project) {
      switch (this.project.status.situation) {
        case 'Extinguished': { // Extingido
          enabled = false;
          break;
        }
        case 'Cancelled': { // Cancelado
          enabled = false;
          break;
        }
        case 'Support': { // Modo soporte
          enabled = false;
          break;
        }
      }
    }
    return enabled;
  }

  public editText(contract, executionPhase: ExecutionDivisionDTO) {
    let title = '[' + contract.division.name + '] ' + this.translate.instant('Contracts.ExecutionPhases.edit.title');
    let context = new LongTextDTOModal('', '', false);
    let config: DynamicDialogConfig = {
      header: title,
      width: '50%',
      styleClass: 'formEdition'
    };

    context.label = this.translate.instant('Contracts.ExecutionPhases.edit.fieldname');
    context.text = (executionPhase && executionPhase.name) ? executionPhase.name : '';
    config['context'] = context;

    const ref = this.dialogService.open(LongTextEditorComponent, config);
    this.subscribe(ref.onClose, result => {
      if (result) {

        console.log('ESTABLEDIENDO TEXTO: ');
        console.log(result);
        if (executionPhase) {
          executionPhase.name = result;
          this.updateExecutionPhase(contract, executionPhase)
        } else {
          this.newExecutionPhase(contract, result);
        }

      }
    });
  }

  public buttonDeleteDisabled(contract: ContractDTO, execDivision?: ExecutionDivisionDTO): Observable<any> {
    if (execDivision && execDivision['EXT_DATA_DIV_DElETING'] === true)
      return of('disabled');


    if (execDivision.phase && execDivision.phase.identifier && '40<>EXPFASE' !== execDivision.phase.identifier)
      return of('disabled');

    return this.buttonsDisabled(contract, execDivision);

  }

  public buttonEditDisabled(contract: ContractDTO, execDivision?: ExecutionDivisionDTO): Observable<any> {
    if (this.isExecutionPhaseClosed(execDivision)) {
      return of('disabled');
    }

    return this.buttonsDisabled(contract, execDivision);

  }


  public buttonsDisabled(contract: ContractDTO, execDivision?: ExecutionDivisionDTO): Observable<any> {
    if (contract?.division?.phase?.identifier == undefined) {
      return of(null);
    }
    // Si el contrato no esta en fase de ejecucion no se habilitan
    if (contract?.division?.phase?.identifier !== '40<>EXPFASE') {
      return of('disabled');
    }

    // Si la fase de ejecucion no esta en ejecucion tampoco
    if (execDivision != null &&
      execDivision?.executionStatus !== 'RUNNING' &&
      execDivision?.executionStatus !== 'RUNNING_RESTRICTED' &&
      execDivision?.executionStatus !== 'CLOSED') {
      return of('disabled');
    }


    // Y si el expediente esta en modo soporte y nuestro usuario no esta permitido tampoco
    if (!this.project.userAllowedForSupport) {
      return of('disabled');
    }

    // Los acuerdos marcos no lo permiten
    if (this.project?.classification?.complementarySystem?.identifier == 'AM<>SISTCOMPLEMENTARIO') {
      return of('disabled');
    }


    // Revisamos los perfiles DEL APLICATIVO de ese expediente
    let profiles = this.appConfig.getValue('contracts.perfilVerBotonPagos'); // En el applet se gestiona con la propiedad 'FraSelExpediente.perfilVerBotonPagos'


    let isProfileAllowed = true;
    let isSituationAllowed = true;
    let isStateAllowed = true;
    let isFillingStateAllowed = true;

    if (profiles != null && profiles != undefined) {
      isProfileAllowed = this.userService.hasRoles(profiles, this.project.documentClass.application);
    }

    // Y si esta archivado
    let fillingState: string = this.project.status.filingState;
    if (fillingState != null && fillingState != undefined) {
      isFillingStateAllowed = fillingState === 'NotFiled';
    }

    if (isFillingStateAllowed) {

      // Y la situacion
      let stSituations = this.propertyService.instant('FraSelExpediente.situacionOcultaBotonPagos');

      if (stSituations != null && stSituations != undefined) {
        let projectSituation = this.project.status.situation;
        let situations = stSituations.split(';');
        let situationDefinitions = Object.values(DossierSituation);
        situations.forEach(stSituation => {
          let intSituation = +stSituation;
          let situation = situationDefinitions[intSituation];
          if (situation === projectSituation) {
            isSituationAllowed = false;
          }
        });

      }

      if (isSituationAllowed) {
        // Y los estados
        let stStates = this.propertyService.instant('FraSelExpediente.estadosOcultaBotonPagos');
        let projectState = this.project.status.state.identifier;
        if (stStates != null && stStates != undefined) {
          let states = stStates.split(';');
          states.forEach(state => {
            let normalizedState = state + '<>EXPESTADO';
            if (normalizedState == projectState) {
              isStateAllowed = false;
            }
          });
        }
      }
    }

    return of(isProfileAllowed && isFillingStateAllowed && isSituationAllowed && isStateAllowed ? null : 'disabled');
  }


  deleteExecutionDivision(contract: ContractDTO, execDivision?: ExecutionDivisionDTO) {

    this.uiService.showConfirmMessage({
      message: this.translate.instant('ExpenseManagement.actions.cancelDocument.message'),
      header: this.translate.instant('General.confirmtext'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.doDeleteExecutionDivision(contract, execDivision)
    });
  }

  doDeleteExecutionDivision(contract: ContractDTO, execDivision?: ExecutionDivisionDTO) {
    if (execDivision) {
      if (execDivision['EXT_DATA_DIV_DElETING'] == true)
        return;
      execDivision['EXT_DATA_DIV_DElETING'] = true;
    }
    this.subscribe(
      this.plycaService.runActionByName('DELETE_EXECUTION_DIVISION', 'TARGET=' + execDivision.identifier),
      (result: ActionResultDTO) => {
        console.log(result);
        if (result && result.identifier === 'OK') {
          this.loadExecutionDivisions(contract);
        } else {
          let isWarning = result.validationResult != null && result.validationResult.result === ResultTypeDTO.WARNING;
          this.uiService.showMessage(this.translate.instant(result.description), this.translate.instant(isWarning ? 'General.warning' : 'General.error'));
        }
        if (execDivision) {
          execDivision['EXT_DATA_DIV_DElETING'] = false;
        }
      },
      () => {
        this.plycaErrorHandler.showServerError(
          this.translate.instant('adaptation.cixtec.bitacoraIntegration.supportEventForm.messages.supportEventCreateProcessResultError')
        );
        if (execDivision) {
          execDivision['EXT_DATA_DIV_DElETING'] = false;
        }
      }
    );
  }


  editExecutionDivision(contract: ContractDTO, execDivision?: ExecutionDivisionDTO) {
    let title = '[' + contract.division.name + '] ' + this.translate.instant('Contracts.ExecutionPhases.edit.title');
    let config: DynamicDialogConfig = {
      header: title,
      width: '70%',
      style: { overflow: 'scroll' },
      styleClass: 'formEdition'
    };
    config['contract'] = contract;
    if (execDivision) {
      config['id'] = execDivision.identifier;
    }

    const ref = this.dialogService.open(
      ExecutionDivisionEditionComponent,
      config
    );

    ref.onClose.pipe(take(1)).subscribe(result => {
      this.loadExecutionDivisions(contract);
    });
  }


  public viewText(executionPhase: ExecutionDivisionDTO) {
    let context = new LongTextDTOModal('', '', true

    );


    let config: DynamicDialogConfig = {
      header: '',
      width: '50%',


      styleClass: 'searchStyle'
    };

    context.label = this.translate.instant('Contracts.ExecutionPhases.edit.name');
    context.text = executionPhase.name;
    config['context'] = context;



    const ref = this.dialogService.open(LongTextEditorComponent, config);
    this.subscribe(ref.onClose);
  }
  public isInitialPhase(contract: ContractDTO) {
    let result = false;
    if (contract.division.project.phase.identifier === '0<>EXPFASE') {
      result = true;
    }
    return result;
  }

  isContractExecutionEnabled() {
    try {
      let contractExecutionEnabled = this.appConfig.getValueByDossierType(this.project.documentClass.application, 'contractExecution.enabled');
      if (contractExecutionEnabled == undefined) {
        return this.appConfig.getValue('contractExecution.enabled');
      }
      return contractExecutionEnabled;
    } catch { }
    return true;
  }

  isContractConfigurationEnabled() {
    return this.appConfig.getValue('contractConfiguration.enabled');
  }

  isExecutionMonitoringModuleEnabled() {
    return this.userService.hasModulesAccess(["SEGCON"]);
  }

  isNewContractModificationVisible() {
    return (this.newContractModificationVisible || this.contractModificationReplyca);
  }

  public getFirmantes(doc: DocumentDTO) {
    if (doc && doc.currentVersion && doc.currentVersion.signers) {
      return doc.currentVersion.signers.map(e => e.name).join(', ');
    }
    return '';
  }

  isContractEspecialesEjecucionEnabled(contract: ContractDTO) {
    return contract.contractLots && contract.contractLots.filter(
      contractLot => contractLot.specialExecutionConditions
        && contractLot.specialExecutionConditions.length > 0).length > 0;
  }

  getSimpleIdentifierFromString(division: DivisionDTO) {
    return getSimpleIdentifierFromString(division.identifier);
  }

  getModificationsFiltered(contract: ContractDTO, onlyExtensions: boolean): ContractModificationDTO[] {
    if (contract['EXT_DATA_CONTRACTMODIFICATIONS'] && contract['EXT_DATA_CONTRACTMODIFICATIONS'].length > 0) {
      if (this.activeExtensionBreakdown) {
        if (onlyExtensions) {
          return contract['EXT_DATA_CONTRACTMODIFICATIONS'].filter(x => x.alias == 'PRC');
        } else if (!onlyExtensions) {
          return contract['EXT_DATA_CONTRACTMODIFICATIONS'].filter(x => x.alias != 'PRC');
        }
      } else {
        return contract['EXT_DATA_CONTRACTMODIFICATIONS'];
      }
    } else {
      return [];
    }
  }

  isLastEditableModifByType(contract: ContractDTO, _contactModification: ContractModificationDTO) {
    if (_contactModification && contract['EXT_DATA_CONTRACTMODIFICATIONS'] && contract['EXT_DATA_CONTRACTMODIFICATIONS'].filter(
      x => x.alias == _contactModification.alias
        && Number(getSimpleIdentifierFromString(x.division.identifier)) < Number(getSimpleIdentifierFromString(_contactModification.division.identifier))
        && (!x.document || x.document.currentState.identifier === '17')
    ).length == 0) {
      return true;
    }
    return false;
  }

  statusInList(status: string, statusesList: string): boolean {
    const lista = statusesList.split(',').map(item => item.trim());
    return lista.includes(getSimpleIdentifierFromString(status));
  }

  loadContractConfiguration(contract: ContractDTO) {
    // si no esta habilitado el modulo no hacemos nada
    if (!this.isContractConfigurationEnabled()) {
      return;
    }
    let attributeValuesId = 'VAL_CONFIG_CONTRATO_STD';
    let attributes = this.appConfig.getValue('contractConfiguration.attributes').split(';');
    contract['configurations'] = [];

    // Array para almacenar las observables de las llamadas a `getAttributeValue`
    const observables = [];
    attributes.forEach(attributeId => {
      let defaultAtribParams = 'ALIASATRIBUTO=' + attributeId +
        '&PROPUESTAID=' + this.dossierId +
        '&DIVISION=' + getSimpleIdentifierFromString(contract.division.identifier);
      // para recuperar siempre los atributos en el mismo orden
      observables.push(this.plycaService.getAttributeValue(attributeValuesId, defaultAtribParams));
    });
    // Utilizar forkJoin para esperar a que todas las llamadas se completen
    forkJoin(observables).subscribe(results => {
      // `results` contendrá un array con los resultados de todas las llamadas, en el mismo orden en que se agregaron las observables
      // Iterar sobre los resultados y procesarlos
      results.forEach((resp, index) => {
        if (resp) {
          contract['configurations'].push({
            'attributeId': attributes[index],
            'value': this.getAttributeSingleValue(resp)
          });
        }
      });
    });
  }

  getAttributeSingleValue(value) {
    return value?.values[0]?.columns?.VALORATRIBUTO?.value;
  }

  updateAttributeValue(contract: ContractDTO, configuration: any) {
    this.subscribe(this.plycaService.getAttribute(configuration.attributeId).pipe(finalize(() => {
      console.log('finalize attrib');
    })),
      attrib => {
        let entidadId = contract.identifier;
        attrib.parameters[0].value = entidadId;
        // attrib.value = {
        //   'singleValue': value
        // };
        // TODO: REVISAR ESTA ESTRUCTURA. ES INFUMABLE
        attrib.value = {
          'values': [
            {
              'columns': {
                'VALORATRIBUTO': {
                  'name': 'VALORATRIBUTO',
                  'value': configuration.value
                }
              }
            }
          ]
        };
        this.plycaService.putAttributeValue(attrib).subscribe(() => {
          configuration.active = false;
          this.loadContractConfiguration(contract);
        });
      }
    );
  }

  edit(configuration: any) {
    configuration.active = true;
  }

  cancelEdit(contract: ContractDTO, configuration: any) {
    configuration.active = false;
    this.loadContractConfiguration(contract);
  }

  showExecutionDivisionDocuments(executionDivision: any) {

    if (this.project.identifier) {
      let contractName = this.getContractName(executionDivision);
      if (contractName == null) {
        contractName = this.project.contractFolderId + (this.project.abbreviatedTitle !== undefined ? ': ' + this.project.abbreviatedTitle : '');
      } else {
        contractName = '[' + contractName + ']';
      }
      let title =
        contractName +
        ' ' + executionDivision.name;
      let filters = {
        avoidTemporaryDocs: false,
        division: getSimpleIdentifierFromString(executionDivision)
      }
      this.documentService.openDossierDocumentsDialog(this.project.identifier, title, filters);
    }
  }
  getContractName(executionDivision: any) {
    let contractName = null;
    if (this.contractList && executionDivision.parent) {
      let contractDiv = getSimpleIdentifierFromString(executionDivision.parent.identifier);
      this.contractList.forEach(con => {

        if (con.division) {
          let conDivId = getSimpleIdentifierFromString(con.division.identifier);
          if (conDivId == contractDiv && con.division.name)
            contractName = con.division.name;
        }
      });
    }
    return contractName;
  }

  openWindowCompany(row: CompanyDTO) {

    let config: DynamicDialogConfig = {
      header: this.translate.instant('CompanyAdmin.title'),
      width: '70%',
      style: { overflow: 'scroll' },
      styleClass: 'formEdition'

    };

    if (row.identifier) {
      this.subscribe(this.plycaService.get(this.configuration.COMPANY_SERVICE_URL, row.identifier), param => {
        let company: CompanyDTO = (param as CompanyDTO);
        config['item'] = new ViewDTOModal(company, 'companyDetailISettings.json');
        config['esAltaEmpresa'] = false;
        config['readOnly'] = true;

        const ref = this.dialogService.open(
          CompanyAdminComponent,
          config
        );
      });
    }

  }

  public openRilFile(contract: ContractDTO) {
    let companyProject = contract['EXT_DATA_RIL_DOSSIER'];
    if (companyProject) {
      //this.router.navigate(['/dossierInfo/' + companyProject.identifier], { queryParams: { component: 'DOCUMENTS', } });
      let text = companyProject.company.commercialName != undefined ? ': ' + companyProject.company.commercialName : companyProject.company.name
      let title = '[' + companyProject.company.taxIdentifier + '] - ' + text;
      this.documentService.openDossierDocumentsDialog(companyProject.identifier, title);
    }

  }

  public getRepresentative(contract: ContractDTO): RepresentativeDTO {
    if (contract.representative && contract.representative.identifier) {
      let representative = contract.company.representatives.find(x => x.identifier == contract.representative.identifier);
      return representative;
    }
    return null;
  }
}
